import AnalyticsService from "./v2/services/AnalyticsService/AnalyticsService";

const wbAnalyticsv2 = new AnalyticsService();
export const init = wbAnalyticsv2.init.bind(wbAnalyticsv2);
export const getVisitUUID = wbAnalyticsv2.getVisitUUID.bind(wbAnalyticsv2);
export const publishCdmEvents =
  wbAnalyticsv2.publishCdmEvents.bind(wbAnalyticsv2);
export const isInited = wbAnalyticsv2.isInited.bind(wbAnalyticsv2);
export const getDebuggedState =
  wbAnalyticsv2.getDebuggedState.bind(wbAnalyticsv2);
export const getVisitUUIDCookieOrZeroed =
  wbAnalyticsv2.getVisitUUIDCookieOrZeroed.bind(wbAnalyticsv2);
export const getCachedEventsBeforeConsent =
  wbAnalyticsv2.getCachedEventsBeforeConsent.bind(wbAnalyticsv2);
export const setCachedEventsBeforeConsent =
  wbAnalyticsv2.setCachedEventsBeforeConsent.bind(wbAnalyticsv2);
export const getConsentId = wbAnalyticsv2.getConsentId.bind(wbAnalyticsv2);
export const getGroupsId = wbAnalyticsv2.getGroupsId.bind(wbAnalyticsv2);
export const getConsent = wbAnalyticsv2.getConsent.bind(wbAnalyticsv2);
export const ensureValidCookie =
  wbAnalyticsv2.ensureValidCookie.bind(wbAnalyticsv2);
